import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Grid from '@material-ui/core/Grid'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import _ from 'lodash'
import { reduxForm} from 'redux-form'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import CryptoJS from "crypto-js";
import ReactSelect from 'react-select';
import CopyToClipboard from 'react-copy-to-clipboard';
import * as tip from '../../../../../uis/tip/reduces'
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';
import Textarea from '../../../../../uis/form/textarea';
import Select from '../../../../../uis/form/select'
import Upload from '../../../../../uis/form/upload';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflow: 'hidden',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 400,
        margin: theme.spacing.unit
    },
    doubleTextField: {
        width: (400 * 2) + (theme.spacing.unit * 8),
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    formControl: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
    images: {
        width: '100%'
    },
    imagesUl: {
        display: 'flex',
        flexFlow: 'row wrap'
    },
    imageWrapper: {
        width: 'calc((100% - 6%) / 3)',
        margin: '0px 1% 50px',
        display: 'flex',
        flexFlow: 'column wrap',
        alignItems: 'center',
        '&:hover $imageHover': {
            opacity: 0.95
        }
    },
    imageSrc: {
        width: '100%',
        position: 'relative',
        height: 270,
        overflow: 'hidden'
    },
    imageHover: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        flexFlow: 'column wrap',
        width: '100%',
        height: '100%',
        background: '#fff',
        opacity: 0,
        transition: '0.5s all'
    },
    imageButton: {
        position: 'absolute',
        left: '30%',
        top: '55%',
        width: 80,
        height: 35,
        lineHeight: 2.2,
        textAlign: 'center',
        background: '#459fed',
        color: '#fff',
        display: 'block',
        borderRadius: 50,
        boxShadow: '0px 1px 1px 0px #0156a0'
    },
    imageTitle: {
        textAlign: 'center',
        marginTop: 20
    }
})

const validate = values => {
    const errors = {}
    if (!values.title) {
        errors.title = '必填'
    }
    if (!values.keywords) {
        errors.keywords = '必填'
    }
    if (!values.serialNum) {
        errors.serialNum = '必填'
    }
    if (!values.serialNum) {
        errors.serialNum = '必填'
    }
    return errors
}

class AddDialog extends React.Component {
    handleLabelsChange = (selectOption) => {
        const {change} = this.props;
        console.info(selectOption);
        change('templateAreaId', selectOption.id);
        change('templateAreaSecondName', selectOption.name);
        change('templateAreaFirstId', selectOption.parentId);
        change('templateAreaFirstName', selectOption.parentName);
        
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, templateAreas} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth={'md'}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <Text name="title" label="标题" placeholder="请输入标题" className={classes.doubleTextField} required={true} />
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="companyType" label="公司类型" placeholder="请输入公司类型" className={classes.textField} required={true} data={[{"name":"森动","value":"森动"},{"name":"建站盒子","value":"建站盒子"},{"name":"原创","value":"原创"},{"name":"其他","value":"其他"}]}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="productType" label="产品类型" placeholder="请输入产品类型" className={classes.textField} required={true} data={[{"name":"展示","value":"展示"},{"name":"电商","value":"电商"}]}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="defaultLanguage" label="默认语言" placeholder="请输入默认语言" className={classes.textField} required={true} data={[{"name":"中文","value":"cn"},{"name":"英语","value":"en"}]}/>
                        </Grid>
                        <Grid item xs={12}>
                            <ReactSelect
                                placeholder={'请选择行业'}
                                onChange={this.handleLabelsChange}
                                options={templateAreas}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Textarea name="keywords" label="关键词" placeholder="请输入关键词" className={classes.doubleTextField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="serialNum" label="编号" placeholder="请输入编号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="previewUrl" label="预览链接" placeholder="请输入预览链接" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Upload name="pcImgUrl" id="pcImgUrl" label="pc端预览图" placeholder="请输入pc端预览图" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Upload name="mImgUrl" id="mImgUrl" label="移动端预览图" placeholder="请输入移动端预览图" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="qrcodeUrl" label="二维码" placeholder="请输入二维码" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="gitRepository" label="仓库地址" placeholder="请输入仓库地址" className={classes.textField} required={false} />
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="refer" label="原网站链接" placeholder="请输入原网站链接" className={classes.doubleTextField} required={false}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    handleLabelsChange = (selectOption) => {
        const {change} = this.props;
        console.info(selectOption);
        change('templateAreaId', selectOption.id);
        change('templateAreaSecondName', selectOption.name);
        change('templateAreaFirstId', selectOption.parentId);
        change('templateAreaFirstName', selectOption.parentName);
        
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, initialValues, templateAreas} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth={'md'}
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <Text name="title" label="标题" placeholder="请输入标题" className={classes.doubleTextField} required={true} />
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="companyType" label="公司类型" placeholder="请输入公司类型" className={classes.textField} required={true} data={[{"name":"森动","value":"森动"},{"name":"建站盒子","value":"建站盒子"},{"name":"原创","value":"原创"},{"name":"其他","value":"其他"}]}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="productType" label="产品类型" placeholder="请输入产品类型" className={classes.textField} required={true} data={[{"name":"展示","value":"展示"},{"name":"电商","value":"电商"}]}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Select name="defaultLanguage" label="默认语言" placeholder="请输入默认语言" className={classes.textField} required={true} data={[{"name":"中文","value":"cn"},{"name":"英语","value":"en"}]}/>
                        </Grid>
                        <Grid item xs={12}>
                            <ReactSelect
                                placeholder={'请选择行业'}
                                defaultValue={templateAreas.find(item => item.value === initialValues.templateAreaId)}
                                onChange={this.handleLabelsChange}
                                options={templateAreas}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Textarea name="keywords" label="关键词" placeholder="请输入关键词" className={classes.doubleTextField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="serialNum" label="编号" placeholder="请输入编号" className={classes.textField} required={true}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="previewUrl" label="预览链接" placeholder="请输入预览链接" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Upload name="pcImgUrl" id="pcImgUrl" label="pc端预览图" placeholder="请输入pc端预览图" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Upload name="mImgUrl" id="mImgUrl" label="移动端预览图" placeholder="请输入移动端预览图" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="qrcodeUrl" label="二维码" placeholder="请输入二维码" className={classes.textField} required={false}/>
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="gitRepository" label="仓库地址" placeholder="请输入仓库地址" className={classes.textField} required={false} />
                        </Grid>
                        <Grid item xs={6}>
                            <Text name="refer" label="原网站链接" placeholder="请输入原网站链接" className={classes.doubleTextField} required={false}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        return {
            initialValues: {
                companyType: '原创',
                productType: '展示',
                defaultLanguage: 'cn'
            }
        }
    },
)(reduxForm({
    form: 'siteTemplateAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => ({
      initialValues: state.siteTemplate.detail
    }),
  )(reduxForm({
    form: 'siteTemplateUpdateForm'
})(UpdateDialog))

class Sitetemplate extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getCompanyDetail())
        dispatch(actions.getTemplateAreaList())
        dispatch(actions.getFirstGroupList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        if (name === 'templateAreaFirstName') {
            dispatch({type: actions.CHANGE_QUERY,key: 'templateAreaSecondName',value: ''});
            if (e.target.value) {
                dispatch(actions.getSecondGroupList(e.target.value))
            }
        }
        dispatch(actions.getList())
    }
    getPreviewLink = (keyword) => {
        const aseKey = "juan"     //秘钥必须为：8/16/32位
        //加密
        const value = CryptoJS.DES.encrypt(keyword, CryptoJS.enc.Utf8.parse(aseKey), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
        return `http://${process.env.NODE_ENV !== 'production' ? '127.0.0.1:3001' : 'zhigui.xuansiwei.com'}/j/${value.replace(/\//g, '%2f')}`
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal, firstGroups, secondGroups} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['模板中心_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    <Grid item xs="12" style={{marginTop: 20}}>
                        一级分类：
                    </Grid>
                    <Grid item xs="12">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <RadioGroup
                                name="templateAreaFirstName"
                                className={classes.group}
                                value={query.templateAreaFirstName}
                                onChange={(e) => this.changeQuery(e,'templateAreaFirstName')}
                            >
                                <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{firstGroups ? firstGroups.reduce((prev, current) => prev + current[1], 0) : 0}）</span></p>} />
                                {firstGroups && firstGroups.map(([name, count]) => {
                                    return <FormControlLabel value={name ? name : 'null'} control={<CopyToClipboard text={this.getPreviewLink(name)} onCopy={() => dispatch(tip.success('复制成功'))}><Radio /></CopyToClipboard>} label={<p>{name ? name : '未分配'}<span style={{color: 'red'}}>（{count}）</span></p>} />
                                })}
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    {secondGroups.length > 0 && <Grid item xs="12" style={{marginTop: 20}}>
                        二级分类：
                    </Grid>}
                    {secondGroups.length > 0 && <Grid item xs="12">
                        <FormControl component="fieldset" className={classes.formControl}>
                            <RadioGroup
                                name="templateAreaSecondName"
                                className={classes.group}
                                value={query.templateAreaSecondName}
                                onChange={(e) => this.changeQuery(e,'templateAreaSecondName')}
                            >
                                <FormControlLabel value="" control={<Radio />} label={<p>全部<span style={{color: 'red'}}>（{secondGroups ? secondGroups.reduce((prev, current) => prev + current[1], 0) : 0}）</span></p>} />
                                {secondGroups && secondGroups.map(([name, count]) => {
                                    return <FormControlLabel value={name ? name : 'null'} control={<CopyToClipboard text={this.getPreviewLink(name)} onCopy={() => dispatch(tip.success('复制成功'))}><Radio /></CopyToClipboard>} label={<p>{name ? name : '未分配'}<span style={{color: 'red'}}>（{count}）</span></p>} />
                                        
                                })}
                            </RadioGroup>
                        </FormControl>
                    </Grid>}
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                                hideCancelBtn={true}
                                onKeyUp={(e)=>{if(e.keyCode === 13){dispatch(actions.getList())}}}
                            />
                        );
                    })}
                    <Button onClick={() => dispatch(actions.getList())}>点击查询</Button>
                    {query.indexField && <CopyToClipboard text={this.getPreviewLink(query.indexField)} onCopy={() => dispatch(tip.success('复制成功'))}>
                        <a style={{marginLeft: 20, lineHeight: '48px', color: 'rgba(0, 0, 0, 0.6)', textDecoration: 'underline', cursor: 'pointer'}}>点击复制预览链接</a>
                    </CopyToClipboard>}
                </Grid>
                
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <div className={classes.images}>
                        <ul className={classes.imagesUl}>
                            {list.map(item => {
                                return <li className={classes.imageWrapper}>
                                    <div className={classes.imageSrc}>
                                        <img src={`${item.pcImgUrl}?x-oss-process=style/small`} alt="" style={{width: '100%'}} />
                                        <div className={classes.imageHover}>
                                            <a href={item.previewUrl} className={classes.imageButton} target="_blank">查看</a>
                                            <img src={`${item.mImgUrl}?x-oss-process=style/small`} alt="" style={{position: 'absolute', left: '60%', width: '28%', bottom: 'auto'}} />
                                        </div>
                                    </div>
                                    <p className={classes.imageTitle}>[{item.serialNum}]{item.title}</p>
                                    <p>
                                        {permissionMap['模板中心_修改'] && <a href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(item.id, false))}>修改</a>}&nbsp;&nbsp;
                                        {permissionMap['模板中心_删除'] && <a href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: item.id})}>删除</a>}&nbsp;&nbsp;
                                        {(permissionMap['模板中心_修改'] && !item.gitRepository) && <a href={`http://init.template.sungdell.com/?name=${item.serialNum}&tempDomain=template.jiaogeiwo.cn`} target="_blank">初始化</a>}
                                        {item.gitRepository && <a href={`http://${item.serialNum}.template.jiaogeiwo.cn:8000/njs/code/analyze-result/${item.serialNum}`} target="_blank">网站分析</a>}
                                    </p>
                                </li>
                            })}
                        </ul>
                    </div>}
                    {/* {list.length > 0 && <div >
                        <GridList>
                            {list.map(item => (
                                <GridListTile key={item.id} style={{height: 450}}>
                                    <img src={item.pcImgUrl} alt={item.title} />
                                    <GridListTileBar
                                    title={<a style={{color: '#fff'}} target="_blank" href={`http://${item.previewUrl}`}>{item.title}</a>}
                                    subtitle={<span>编号: {item.serialNum}&nbsp;&nbsp;
                                        {permissionMap['模板中心_修改'] && <a style={{color: '#fff'}} href={`javascript:;`} onClick={()=>dispatch(actions.showUpdateModal(item.id, false))}>修改</a>}&nbsp;&nbsp;
                                        {permissionMap['模板中心_删除'] && <a style={{color: '#fff'}} href={`javascript:;`} onClick={()=>dispatch({type: actions.SHOW_MODAL,key: 'delete', id: item.id})}>删除</a>}
                                    </span>}
                                    />
                                </GridListTile>
                            ))}
                        </GridList>
                        </div>} */}
                    <div>
                        <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                    </div>
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.siteTemplate,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(Sitetemplate))


// WEBPACK FOOTER //
// ./src/pages/home/routes/site_template/components/list.js